// extracted by mini-css-extract-plugin
export var arrow = "Overlay-module--arrow--8229a";
export var arrowNo = "Overlay-module--arrow_no--527a1";
export var arrowYes = "Overlay-module--arrow_yes--70f6e";
export var flex = "Overlay-module--flex--c3313";
export var flex1 = "Overlay-module--flex_1--ebf5f";
export var flexCenter = "Overlay-module--flex_center--f2dee";
export var flexCenterCol = "Overlay-module--flex_center_col--03ce8";
export var flexCol = "Overlay-module--flex_col--87d63";
export var flexFixCenterCol = "Overlay-module--flex_fix_center_col--2d2ec";
export var flexFixedCenterCol = "Overlay-module--flex_fixed_center_col--583fc";
export var overlay = "Overlay-module--overlay--f5ec3";
export var rotating = "Overlay-module--rotating--e9bb5";